import { DateField as MuiDateField } from "@mui/x-date-pickers-pro";
import { InputErrorMessage } from "src/components/InputErrorMessage/InputErrorMessage.tsx";
import { PickerTextField } from "src/components/DatePickerV2/PickerTextField.tsx";
import React, { type CSSProperties, forwardRef } from "react";
import type { DatePickerProps, PickerValidDate } from "@mui/x-date-pickers-pro";
import * as styles from "./DateField.styles.ts";
import { BaseInputV2Adornment } from "src/components/BaseInputV2/BaseInputV2Adornment.tsx";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { InputLabel } from "src/components/InputLabel/InputLabel.tsx";

type Props = {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  style?: CSSProperties;
} & Omit<DatePickerProps<PickerValidDate>, "label">;

const ClearIcon = forwardRef(({ ownerState, ...restProps }: any, ref: any) => {
  return <i ref={ref} {...restProps} className="icon-15-clear_x" />;
});
const ClearButton = forwardRef(({ ownerState, ...restProps }: any, ref) => {
  return <BaseInputV2Adornment ref={ref} isAction={true} {...restProps} />;
});

const muiTheme = createTheme();
export const DateField = (props: Props) => {
  const { label, error, helperText, required, style, disabled, ...restProps } =
    props;

  return (
    <div css={styles.root} style={style}>
      {label && (
        <InputLabel label={label} required={required} helperText={helperText} />
      )}
      <MuiThemeProvider theme={muiTheme}>
        <MuiDateField
          css={styles.datePicker}
          clearable={true}
          disabled={disabled}
          slots={{
            textField: PickerTextField,
            clearButton: ClearButton,
            clearIcon: ClearIcon,
          }}
          {...(restProps as DatePickerProps<PickerValidDate>)}
        />
      </MuiThemeProvider>
      {!!error && <InputErrorMessage message={error} />}
    </div>
  );
};
